module.exports = __webpack_public_path__ + "img/14.a44a8917.webp";